import React from 'react';
import { Outlet } from 'react-router-dom';
import { Container } from './HomePage.styles';
import HomeNavigator from '../../components/HomeNavigator/HomeNavigator';

const HomePage = () => {
  return (
    <Container>
      <Outlet />
      <HomeNavigator />
    </Container>
  );
};

export default HomePage;
